import React from 'react';
import {
	FormControl,
	Input, InputLabel,
	Select
} from '@material-ui/core';


const SelectInput = ({
	floatingText,
	id,
	value = 0,
	onChange,
	errorText,
	children,
	required,
	disabled,
	noLabel,
	labelStyle = {},
	autoWidth,
	styles,
	disableUnderline = false,
	styleLabel
}) => (
	<FormControl
		error={!!errorText}
		style={{
			width: '100%',
			marginTop: '0',
			marginBottom: '8px'
		}}
	>
		{!noLabel && (
			<InputLabel htmlFor={id}><span style={{ ...styleLabel }}>{`${floatingText || ''}${required ? '*' : ''
		}`}</span></InputLabel>
		)}
		<Select
			disableUnderline={disableUnderline}
			inputProps={{
				name: floatingText,
				id,
				style: {
					fontSize: '12px !important',
					...labelStyle
				}
			}}
			input={
				<Input />
			}
			autoWidth={autoWidth}
			disabled={!!disabled}
			value={value}
			onChange={onChange}
			error={!!errorText}
			style={{ ...styles }}
		>
			{children}
		</Select>
		{errorText && <span style={{ color: 'red', fontSize: '12px' }}>{errorText}</span>}
	</FormControl>
);


export default SelectInput;
